// import global components
import Breadcrumb from "./components/shared/Breadcrumb.vue";
import CustomBreadcrumb from "./components/shared/CustomBreadcrumb.vue";
import Notification from "./components/shared/Notification.vue";
import NavigationMenu from "./components/shared/NavigationMenu.vue";
import PompeTabs from "./components/shared/Tabs.vue";
import ErrorMessage from "./components/shared/ErrorMessage.vue";
import ErrorMessageNew from "./components/shared/ErrorMessageNew.vue";
import SubHeader from "./components/layouts/SubHeader";

// global form components
import TextField from "./components/reusable/TextField.vue";
import Dropdown from "./components/reusable/Dropdown.vue";
import DatePicker from "./components/reusable/Datepicker.vue";
import RadioButton from "./components/reusable/RadioButton.vue";
import Checkbox from "./components/reusable/Checkbox.vue";
import TextArea from "./components/reusable/TextArea.vue";
import Autocomplete from "./components/reusable/Autocomplete.vue";
import YearPicker from "./components/reusable/YearPicker.vue";
import DetailText from "./components/reusable/DetailText.vue";
import CollapsibleContainer from "./components/reusable/CollapsibleContainer.vue";
import PompeTable from "./components/reusable/PompeTable.vue";
import DropdownTableAction from "./components/reusable/DropdownTableAction.vue";
import DecimalInput from "./components/reusable/FormFields/DecimalInput.vue";
import PhoneNumberInput from "./components/reusable/FormFields/PhoneNumber.vue";
import PopoverButton from "./components/reusable/FormFields/PopoverButton.vue";
import Modal from './components/reusable/Modal/index.vue';

export const registerComponents = (app) => {
  // use global component
  app.component("breadcrumb", Breadcrumb);
  app.component("notification", Notification);
  app.component("navigation-menu", NavigationMenu);
  app.component("error-message", ErrorMessage);
  app.component("error-message-new", ErrorMessageNew);
  app.component("sub-header", SubHeader);

  // Global form component
  app.component("text-field", TextField);
  app.component("dropdown", Dropdown);
  app.component("datepicker", DatePicker);
  app.component("radiobutton", RadioButton);
  app.component("checkbox", Checkbox);
  app.component("text-area", TextArea);
  app.component("autocomplete", Autocomplete);
  app.component("yearpicker", YearPicker);
  app.component("detail-text", DetailText);
  app.component("collapsible-container", CollapsibleContainer);
  app.component("pompe-table", PompeTable);
  app.component("dropdown-table-action", DropdownTableAction);
  app.component("decimal-input", DecimalInput);
  app.component("phone-number-input", PhoneNumberInput);
  app.component("pop-over-button", PopoverButton);
  app.component("pompe-tabs", PompeTabs);
  app.component("modal", Modal);

  return app;
};
